// extracted by mini-css-extract-plugin
export default {"ppDLLogo":"DocTypeButton_ppDLLogo__3sYKg"};